export default __webpack_public_path__ + "static/media/Maa- ja Ruumiamet_sinine.ad9f188d.svg";